/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ITableDataModal } from "pages/StepPages/StepFour/One/Tables/models";
import { useParams } from "react-router-dom";
import ModalPortal from "components-new/ModalPortal";
import sass from "pages/StepPages/StepFour/One/Tables/TableNavigate/LevelsOfVariantsTable/levels.module.sass";
import TextArea from "components-new/Textarea";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import GroupCheck from "components-new/GroupCheck";
import InputTemp from "components-new/InputTemp";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext, ITab } from "pages/StepPages/StepFour/One/Tables/TableNavigate/TableNavigate";
import List from "../ListCurrentThreatsTable/ListTactics";
import { ReactComponent as SearchIcon } from "images/SearchIcon.svg";
import { ImplementThreatWayResponse } from "libs/apiClient/data-contracts";
import { organizationAPI } from "libs/apiClient/Organization";
import { directoryAPI } from "libs/apiClient/Directory";

const initial: Omit<ImplementThreatWayResponse, "method"> & { method: { id: number; name: string }[] } = {
	id: 0,
	type: "",
	outer: false,
	method: [],
	influence: "",
	availableInterface: "",
	inner: false,
};
const PossibkeObjectsModal: React.FC<ITableDataModal<ImplementThreatWayResponse>> = ({
	toggle,
	replace,
	active,
	data = [],
	close,
}) => {
	const [searchTactic, setSearchTactic] = useState("");
	const [optionsTactics, setOptionsTactics] = useState<{ id: number; name: string }[]>([]);
	const [currentObject, setCurrentObject] = useState<
		Omit<ImplementThreatWayResponse, "method"> & { method: { id: number; name: string }[] }
	>(initial);
	const filteredOptionsTactics = useMemo(() => {
		return optionsTactics.filter((_) => _.name.toLowerCase().includes(searchTactic.toLowerCase()));
	}, [searchTactic, optionsTactics]);
	useEffect(() => {
		organizationAPI.objectTacticShortDetail(+params.threadId!).then(({ data }) => {
			setOptionsTactics(data.map((_: string, index: number) => ({ id: index + 1, name: _ })));
		});
		//eslint-disable-next-line
	}, [toggle]);

	const changeTactics = (item: { name: string; id: number }, field: string) => {
		const key = field as keyof typeof currentObject;
		if (
			currentObject[key] &&
			Array.isArray(currentObject[key]) &&
			(currentObject[key] as Array<any>).find((_) => item.name === _.name)
		) {
			setCurrentObject((prevState) => ({
				...prevState,
				[key]: (prevState[key] as any[]).filter((select) => select.name !== item.name),
			}));
		} else {
			setCurrentObject((prevState) => {
				return {
					...prevState,
					[key]: prevState[key] && (prevState[key] as any[]).length ? [...(prevState[key] as any[]), item] : [item],
				};
			});
		}
	};

	const [options, setOptions] = useState<any[]>([]);
	const { changeTab, updateTabs } = useContext(ChangeActiveTabContext);

	const params = useParams();

	const changeField = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setCurrentObject((prevState: any) => {
			return { ...prevState, [name]: value };
		});
	};

	const title = useMemo(() => {
		return `${
			toggle === "edit" ? "Редактирование: " : "Создание: "
		}Актуальные способы реализации угроз безопасности информации и соответствующие им виды нарушителей и их возможности`;
	}, [toggle]);

	useEffect(() => {
		if (active && active.method) {
			const method = active.method.map((_, index) => ({ id: index + 1, name: _ }));
			setCurrentObject({ ...active, method });
		} else {
			setCurrentObject(initial);
		}
	}, [active]);

	useEffect(() => {
		directoryAPI.dropdownViolatorTypesList({ id: +params.threadId! }).then(({ data }) => {
			setOptions(data.map((_: string, index: number) => ({ id: index + 1, name: _ })));
		});
		return () => {
			setOptions([]);
		};
		//eslint-disable-next-line
	}, [toggle]);

	const changeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, checked } = e.target;
		setCurrentObject((prevState) => ({ ...prevState, [name]: checked }));
	};
	const save = () => {
		const method = currentObject.method.map((_) => _.name);
		const { id, ...rest } = currentObject;
		if (toggle === "edit") {
			organizationAPI.objectWayUpdate(id, { ...rest, method }).then((r) => {
				const response = r.data;
				const newData = [...data].map((item) =>
					item.id === response.id
						? {
								...response,
								id: response.id!,
								influence: r.data.influence,
						  }
						: item,
				);
				// .map((_) => (_.id === response.id ? response : _))
				// .map((_) => ({
				// 	..._,
				// 	influence: r.data.influence,
				// }));
				setCurrentObject(initial);
				replace(newData);
				snackWrapper("success", "Таблица обновлена");
				updateTabs("WAY");
				close();
			});
		} else if (toggle === "create") {
			organizationAPI.objectWayCreate(+params.threadId!, { ...rest, method }).then((r) => {
				const newData = [...data, r.data].map((_) => ({ ..._, influence: r.data.influence }));
				setCurrentObject(initial);
				replace(newData);
				snackWrapper("success", "Таблица обновлена");
				updateTabs("WAY");
				close();
			});
		}
	};
	const disabled = useMemo(() => {
		return (
			!currentObject.type || !currentObject.influence || !currentObject.availableInterface || !currentObject.method
		);
	}, [currentObject]);
	return toggle !== null ? (
		<ModalPortal
			outSide={false}
			size={options.length || toggle === "edit" ? "md" : "sm"}
			title={options.length || toggle === "edit" ? title : "Невозможно добавить значение"}
			handleClose={close}>
			<div className={sass.modal}>
				{options.length || toggle === "edit" ? (
					<>
						<InputTemp
							value={currentObject.type}
							options={options}
							field={"name"}
							onSelect={(e) => {
								setCurrentObject((prevState) => ({ ...prevState, type: e.name }));
							}}
							name={"type"}
							label={"Вид нарушителя"}
							required={true}
							placeholder={"Введите текст"}
							onChange={changeField}
						/>
						{/*<TextArea  name={'type'}*/}
						{/*           onChange={changeField}*/}
						{/*           */}
						{/*            rows={5}/>*/}
						<GroupCheck.Wrapper label={"Категория нарушителя"} required={true}>
							<GroupCheck.Item
								onChange={changeCheckbox}
								checked={currentObject.outer!}
								name={"outer"}
								label={"Внешний"}
								type={"checkbox"}
							/>
							<GroupCheck.Item
								onChange={changeCheckbox}
								checked={currentObject.inner!}
								name={"inner"}
								label={"Внутренний"}
								type={"checkbox"}
							/>
						</GroupCheck.Wrapper>
						<TextArea
							name={"influence"}
							onChange={changeField}
							value={currentObject.influence!}
							placeholder={"Введите текст"}
							label={"Объект воздействия"}
							required={true}
							rows={10}
						/>

						<TextArea
							name={"availableInterface"}
							onChange={changeField}
							value={currentObject.availableInterface!}
							placeholder={"Введите текст"}
							label={"Доступные интерфейсы"}
							required={true}
							rows={2}
						/>
						<div className={sass.selectBox}>
							<span className={sass.selectBox_label}>
								Способы реализации <span className={sass.required}>*</span>
							</span>

							<div className={sass.selectBox_list}>
								<div className={sass.selectBox_search}>
									<SearchIcon />
									<input
										value={searchTactic}
										placeholder={"Поиск способов"}
										onChange={(e) => {
											setSearchTactic(e.target.value);
										}}
										type="text"
									/>
								</div>
								<div className={sass.selectBox_list_wrapper}>
									{searchTactic ? (
										filteredOptionsTactics.length ? (
											<List
												data={filteredOptionsTactics}
												check={changeTactics}
												current={currentObject}
												field={"method"}
											/>
										) : (
											<label className={sass.selectBox_list_wrapper_item}>Ничего не найдено</label>
										)
									) : optionsTactics.length ? (
										<List data={optionsTactics} check={changeTactics} current={currentObject} field={"method"} />
									) : (
										<div
											onClick={() => {
												changeTab(
													{
														id: 9,
														tab: "list_of_basic",
														name: "Перечень основных тактик и соответствующих им типовых техник",
													} as ITab,
													false,
												);
											}}
											className={sass.selectBox_list_empty}>
											<span className={sass.link}>Способов реализации пока нет, сформировать способы</span>
										</div>
									)}
								</div>
							</div>
						</div>
						{/*<TextArea*/}
						{/*	name={"method"}*/}
						{/*	onChange={changeField}*/}
						{/*	value={currentObject.method}*/}
						{/*	placeholder={"Введите текст"}*/}
						{/*	label={"Способы реализации"}*/}
						{/*	required={true}*/}
						{/*	rows={2}*/}
						{/*/>*/}

						<div className={sass.btn}>
							<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
								Отменить
							</Button>
							<Button disabled={disabled} onClick={save} variant={BUTTON_VARIANTS.CONTAINED}>
								Сохранить
							</Button>
						</div>
					</>
				) : (
					<p>
						Сначала заполните{" "}
						<span
							className={sass.link_go_to}
							onClick={() =>
								changeTab(
									{
										id: 7,
										tab: "current_violators",
										name: "Актуальные нарушители при реализации угроз безопасности",
									} as ITab,
									false,
								)
							}>
							таблицу 6
						</span>
					</p>
				)}
			</div>
		</ModalPortal>
	) : null;
};

export default PossibkeObjectsModal;
